'use client';

import {
  useGameStatus,
  useTriviaStore,
} from '@wwe-portal/web/providers/stores/trivia-store';
import { TriviaGameLogin } from './trivia-game-login';
import { useGetCurrentUser } from '@wwe-portal/web/providers/queries/user-info';
import { TriviaGamePlayer } from './trivia-game-player';

import styles from './trivia-rumble-panel.module.css';
import { TriviaGameFailed } from './trivia-game-failed';
import { cn } from '../../../../../packages/ui/lib/lib';
import { TriviaGameVictory } from '@wwe-portal/ui/features/trivia/game-victory';
import { TriviaGoHome } from './trivia-go-home';
import { useTriviaRumbleCost } from '@wwe-portal/web/providers/queries/trivia-rumble';
import { usePlayAgainMutation } from '@wwe-portal/web/providers/queries/trivia-rumble.mutation';
import { useTranslations } from 'next-intl';
import { LeavingPageDialog } from '../common/dialog/leaving-page-dialog';

const TriviaGamePanelContent = () => {
  const gameStartAtMs = useTriviaStore((state) => state.gameStartAtMs);
  const gameId = useTriviaStore((state) => state.gameId);
  const gameConfig = useTriviaStore((state) => state.gameConfig);
  const gameWon = useGameStatus() === 'won';
  const gameStarted = gameStartAtMs != null;
  const t = useTranslations();

  const energyCost = gameConfig?.energyCost;
  const gameData = useTriviaStore((state) => state.gameData);
  const currentUser = useGetCurrentUser();
  const energy = currentUser?.energy;
  const { data: triviaCost } = useTriviaRumbleCost();
  const reward = triviaCost?.data.data.reward;
  const { mutate: playAgain, isPending } = usePlayAgainMutation();

  if (gameWon) {
    return (
      <TriviaGameVictory
        gohomeSlot={<TriviaGoHome className="mt-[80px] justify-self-end" />}
        currentPoint={gameData?.currentPoint}
        reward={reward}
        energyCost={energyCost}
        energy={energy}
        isPending={isPending}
        playAgain={playAgain}
        t={t}
      />
    );
  }

  if (!gameStarted || !gameId || !gameConfig || !currentUser) {
    return <TriviaGameLogin />;
  }

  return <TriviaGamePlayer />;
};

export const TriviaGamePanel = () => {
  const gameStatus = useGameStatus();
  const closeGame = useTriviaStore((state) => state.closeGame);
  return (
    <>
      <div
        data-status={gameStatus}
        className={cn(
          'md:bg-midnightExpressShade3 relative h-full rounded-[10px] px-0 pt-5 md:px-[30px]',
          styles.gamePanel
        )}
      >
        <TriviaGamePanelContent />
      </div>
      <TriviaGameFailed />
      <LeavingPageDialog
        isPending={gameStatus !== 'idle'}
        onAccept={closeGame}
      />
    </>
  );
};
